import { render, staticRenderFns } from "./OddRow.vue?vue&type=template&id=ff1dac7c&scoped=true&"
import script from "./OddRow.vue?vue&type=script&lang=js&"
export * from "./OddRow.vue?vue&type=script&lang=js&"
import style0 from "./OddRow.vue?vue&type=style&index=0&id=ff1dac7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1dac7c",
  null
  
)

export default component.exports